import { BaseListFilter } from '../../../models/base-list-filter.model';
import { SvbV2AchDirectionEnum } from '../../svb-v2-ach/models/svb-v2-ach-direction.enum';
import { SvbV2AchStatusEnum } from '../../svb-v2-ach/models/svb-v2-ach-status.enum';

export class SvbBatchListFilters extends BaseListFilter {
  isEligible: boolean;
  effectiveDateFrom: string;
  effectiveDateTo: string;
  status?: SvbV2AchStatusEnum;
  batchId?: string;
  direction?: SvbV2AchDirectionEnum;
}
